import React from 'react'
import BusinessReports from '../../Component/TeamOverview/BusinessReports'
const BusinessReport = () => {
  return (
    <div className='page-body'>
      <BusinessReports/>
    </div>
  )
}

export default BusinessReport